import { render, staticRenderFns } from "./BaseMask.vue?vue&type=template&id=2eecb2e4&scoped=true&"
import script from "./BaseMask.vue?vue&type=script&lang=js&"
export * from "./BaseMask.vue?vue&type=script&lang=js&"
import style0 from "./BaseMask.vue?vue&type=style&index=0&id=2eecb2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecb2e4",
  null
  
)

export default component.exports